import React from "react";
import { Route } from "react-router-dom";
import CreateCourse from "./../../Components/Dashboard/TeacherDashboard/CreateCourse";
import ApprovalStatus from "./../../Components/Dashboard/TeacherDashboard/ApprovalStatus";
import ManageCourse from "./../../Components/Dashboard/TeacherDashboard/ManageCourse";
import ProtectedRoute from "../../Components/ProtectedRoute";
import ManageStudents from "./../../Components/Dashboard/TeacherDashboard/ManageStudents";
import StudentDetails from "./../../Components/Dashboard/TeacherDashboard/StudentDetails";
import CvManagementPage from "../../Components/Dashboard/TeacherDashboard/CvManagementPage";
import ManageEinstufungstest from "./../../Components/Dashboard/TeacherDashboard/ManageEinstufungstest";
import ManagePlacementResults from "./../../Components/Dashboard/TeacherDashboard/ManagePlacementResults";
import TeacherManagerCoursesPage from "../../Components/Dashboard/TeacherDashboard/TeacherManagerCoursesPage";
import TeacherProfile from "../../Components/Dashboard/TeacherDashboard/TeacherProfile";
import TeacherEnglishBoundary from "../../Components/Dashboard/TeacherDashboard/TeacherEnglishBoundary";
import TeacherManagerCourseModerationPage from "../../Components/Dashboard/TeacherDashboard/TeacherManagerCourseModerationPage";
import TeacherManagerCourseInterestsPage from "../../Components/Dashboard/TeacherDashboard/TeacherManagerCourseInterestsPage";
import TeacherApprovalGate from "../../Components/Dashboard/TeacherDashboard/TeacherApprovalGate";
const ForceEnglish = ({ children }) => {
  return <TeacherEnglishBoundary><TeacherApprovalGate>{children}</TeacherApprovalGate></TeacherEnglishBoundary>;
};

/**
 * role: string (optional, for backward compatibility)
 * roleNames: array of roles (optional, preferred)
 */
const TeacherRoutes = (role, roleNames) => {
  const normalizeRole = (value) =>
    String(value || "")
      .trim()
      .toUpperCase()
      .replace(/[\s-]+/g, "_");

  const effectiveRoles = roleNames?.length
    ? roleNames.map(normalizeRole)
    : role
    ? [normalizeRole(role)]
    : [];

  return [
    <Route
      key="teacher-manager-course-moderation"
      path="/teacher-manager/course-moderation"
      element={<ForceEnglish><ProtectedRoute element={<TeacherManagerCourseModerationPage />} allowedRoles={["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles}/></ForceEnglish>}
    />,
    <Route
      key="teacher-manager-course-interests"
      path="/teacher-manager/course-interests"
      element={<ForceEnglish><ProtectedRoute element={<TeacherManagerCourseInterestsPage />} allowedRoles={["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles}/></ForceEnglish>}
    />,
    <Route
      key="teacher-profile"
      path="/teacher-profile"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<TeacherProfile />}
            allowedRoles={["TEACHER", "TEACHER_MANAGER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="create-course"
      path="/create-course"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<CreateCourse />}
            allowedRoles={["TEACHER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="approval-status"
      path="/approval-status"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<ApprovalStatus />}
            allowedRoles={["TEACHER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="manage-course"
      path="/manage-course"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<ManageCourse />}
            allowedRoles={["TEACHER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="manage-students"
      path="/manage-students"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<ManageStudents />}
            allowedRoles={["TEACHER", "TEACHER_MANAGER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="student-details"
      path="/manage-students/student-details/:studentId"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<StudentDetails />}
            allowedRoles={["TEACHER_MANAGER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,

    <Route
      key="teacher-manager-courses"
      path="/teacher-manager-courses"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<TeacherManagerCoursesPage />}
            allowedRoles={["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,

    <Route
      key="cv-management"
      path="/cv-management"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<CvManagementPage />}
            allowedRoles={["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="manage-einstufungstest"
      path="/manage-einstufungstest"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<ManageEinstufungstest />}
            allowedRoles={["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="manage-placement-results"
      path="/manage-placement-results"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<ManagePlacementResults />}
            allowedRoles={["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
  ];
};

export default TeacherRoutes;
